import { Observable, of, take } from 'rxjs';

/**
 * Convert any value to an observable
 * @param value value needed to be converted to observable
 */
export function toObservable<T>(value: T): Observable<T> | null {
  return value !== null || value !== undefined ? of(value).pipe(take(1)) : null;
}
